<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thể loại bài viết</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col>
                                <b-form-group label="Thể loại bài viết:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            selectable
                            dataUrl="master-data/blog-categories"
                            gridName="Danh sách Thể loại bài viết"
                            ref="categoryDiscountCodeTable">
                        <template v-slot:actions v-if="authorize(['ManageBlogCategory'])">
                            <router-link to="/master-data/blog-categories/create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <b-button size="md" @click.stop="deletes" variant="danger" :disabled="isDisabledDelete">
                                Xóa
                            </b-button>
                        </template>
                        <template v-slot:cell(status)="row">
                            <b-form-checkbox v-model="row.value" @change="updateStatus(row.item, $event)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewBlogCategory'])" size="sm" :to="{ path: `./detail/${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template>
                                    <b-button size="sm" v-if="authorize(['ManageBlogCategory'])" :to="{ path: `./edit/${row.item.id}` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" v-if="authorize(['ManageBlogCategory'])" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'ListUnitType',
        mixins: [authorizationMixin],
        data() {
            return {
                searchForm: {
                    str: null
                },
                isDisabledDelete: true,
                gridOptions: {
                    fields: [
                        { key: 'name', label: 'Tên Thể loại bài viết', sortable: true, sortDirection: 'asc' },
                        { key: 'seoTitle', label: 'Tiêu đề seo', sortable: true, sortDirection: 'asc' },
                        { key: 'metaTitle', label: 'Tiêu đề của trang', sortable: true, sortDirection: 'asc' },
                        { key: 'metaKeywords', label: 'Key của trang', sortable: true, sortDirection: 'asc' },
                        { key: 'metaDescriptions', label: 'Mô tả của trang', sortable: true, sortDirection: 'asc' },
                        { key: 'displayOrder', label: 'Vị trí hiển thị', sortable: true, sortDirection: 'asc' },
                        { key: 'status', label: 'Trạng thái', sortable: false },
                    ],
                    sortBy: 'id'
                },
            }
        },
        computed: {

        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.categoryDiscountCodeTable.selectedRows
                },
                (val) => {
                    this.isDisabledDelete = val.length == 0;
                }
            )
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.categoryDiscountCodeTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;

                if (confirm('Bạn có chắc chắn muốn xóa Thể loại bài viết này?')) {
                    this.$services.delete(`master-data/blog-categories/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa Thể loại bài viết thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.categoryDiscountCodeTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các Thể loại bài viết này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/blog-categories?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa Thể loại bài viết thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn Thể loại bài viết cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
</style>
